import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageSEO from '@/components/feature/PageSEO';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categoriesData, categoryBreadcrumbs } from '@/mocks/categoryData';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const data = categoriesData[slug || ''] || categoriesData.products;
  const breadcrumbItems = categoryBreadcrumbs[slug || ''] || categoryBreadcrumbs.products;

  const categorySchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        name: data.title,
        description: data.description,
        url: `http://dajiang03.cn/category/${slug}`,
        isPartOf: {
          '@type': 'WebSite',
          name: 'NOPAY钱包',
          url: 'http://dajiang03.cn/',
        },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems.map((item, idx) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: item.label,
          ...(item.path ? { item: `http://dajiang03.cn/${item.path}` } : {}),
        })),
      },
    ],
  };

  return (
    <>
      <PageSEO
        title={data.title}
        description={data.description}
        keywords={`NOPAY钱包,${data.title},NOPAY,2026世界杯,数字化娱乐`}
        canonicalUrl={`http://dajiang03.cn/category/${slug}`}
        schemaJson={categorySchema}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[50vh] min-h-[350px] flex items-center justify-center overflow-hidden">
          <img
            src={data.heroImage}
            alt={data.title}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
          <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
            <p className="text-foreground-300 text-xs tracking-[0.2em] uppercase font-label mb-3">
              {data.subtitle}
            </p>
            <h1 className="font-heading text-3xl md:text-5xl font-bold text-white mb-4">
              {data.title}
            </h1>
            <p className="text-white/80 text-sm max-w-xl mx-auto mb-6">
              {data.description}
            </p>
            <div className="flex justify-center">
              <Breadcrumb items={breadcrumbItems} />
            </div>
          </div>
        </section>

        <section className="bg-background-100 pt-6 pb-2">
          <div className="mx-auto px-4 md:px-6 max-w-6xl">
            <div className="flex items-center justify-center gap-2 flex-wrap">
              {[
                { slug: 'products', label: '产品中心' },
                { slug: 'worldcup', label: '世界杯专区' },
                { slug: 'news', label: '新闻资讯' },
              ].map((tab) => (
                <button
                  key={tab.slug}
                  onClick={() => navigate(`/category/${tab.slug}`)}
                  className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                    slug === tab.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="mx-auto px-4 md:px-6 max-w-6xl">
            <div className="flex items-center justify-between mb-8">
              <p className="text-foreground-500 text-sm">
                共 <strong className="text-foreground-900">{data.items.length}</strong> 项
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {data.items.map((item) => (
                <Link
                  key={item.id}
                  to={item.link || '#'}
                  className="bg-background-50 rounded-lg overflow-hidden group cursor-pointer"
                >
                  <div className="relative h-52 overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <span className="absolute top-3 right-3 px-2.5 py-1 bg-accent-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <div className="p-4 md:p-5">
                    <p className="text-xs text-foreground-500 mb-1">{item.category}</p>
                    <h3 className="font-heading text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                      {item.name}
                    </h3>
                    <p className="text-sm text-foreground-600">{item.description}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}